import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
export default (props => { return /*#__PURE__*/ _jsx(_Fragment, { children: props.permission.some(v => props.userPermission.includes(v)) && props.children }); });
